module.exports = __webpack_public_path__ + "static/media/BigCaslon-Medium.28d22365.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/BigCaslon-Medium.ttf
// module id = 89
// module chunks = 0